import React, { useState } from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Paper,
  IconButton,
  Tooltip,
  Pagination,
  Link,
} from "@mui/material";
import notificationStore from "../../stores/NotificationStore";
import useTranslation from "../../hooks/useTranslation";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import { Notification } from "../../stores/NotificationStore/types";
import { parseDate } from "../../utils/helperFunctions";

const NotificationsPage = observer(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [markAsReadClickMap, setMarkAsReadClickMap] = useState<{
    [key: string]: boolean;
  }>({});

  const handleChangePage = async (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    const pageIndex = value - 1;

    if (notificationStore.page !== pageIndex) {
      notificationStore.page = pageIndex;
      await notificationStore.fetchNotifications(pageIndex);
    }
  };

  const handleNotificationClick = async (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    n: Notification
  ) => {
    e.preventDefault();
    e.stopPropagation();

    if (n.meta?.caseId) {
      await notificationStore.markAsRead(n._id);
      navigate(`/case/${n.meta.caseId}`);
    }
  };

  const handleMarkAsReadClick = async (
    e: React.MouseEvent,
    n: Notification
  ) => {
    e.stopPropagation();
    setMarkAsReadClickMap({
      [n._id]: true,
    });
    await notificationStore.markAsRead(n._id);
  };

  return (
    <Box className={"container pb"}>
      <Typography
        variant="h5"
        gutterBottom
        marginTop={4}
        style={{ marginTop: "0" }}
      >
        <i className="fal fa-bell" />
        &nbsp;&nbsp;
        {t("notifications")}
      </Typography>
      <List>
        {notificationStore.notifications.map((notification) => (
          <Paper
            key={notification._id}
            style={{ marginBottom: "10px", padding: "10px" }}
          >
            <ListItem
              secondaryAction={
                !notification.isRead ? (
                  <Tooltip title={t("mark-as-read")}>
                    <IconButton
                      disabled={markAsReadClickMap[notification._id]}
                      onClick={(e) => handleMarkAsReadClick(e, notification)}
                      color={"secondary"}
                    >
                      <i className="fal fa-envelope-open" />
                    </IconButton>
                  </Tooltip>
                ) : (
                  <i className="fal fa-check" />
                )
              }
            >
              <ListItemText
                primary={
                  <>
                    {t(`${notification.code.toLowerCase()}_title`)}
                    {notification.createDate && (
                      <Typography
                        color={"GrayText"}
                        fontSize={"12px"}
                        component={"span"}
                      >
                        &nbsp; - ({parseDate(notification.createDate)})
                      </Typography>
                    )}
                  </>
                }
                secondary={
                  <Link
                    href="#"
                    className="pt"
                    style={{ display: "block" }}
                    onClick={(event) =>
                      handleNotificationClick(event, notification)
                    }
                  >
                    {t(`${notification.code.toLowerCase()}_description`, [
                      notification.meta?.caseId || "",
                      notification.meta?.offerId || "",
                      notification.meta?.reason || "",
                    ])}
                    &nbsp;&nbsp;
                    <i className="fal fa-arrow-right" />
                  </Link>
                }
              />
            </ListItem>
          </Paper>
        ))}
      </List>
      <Pagination
        count={notificationStore.notificationsCount / 50}
        page={notificationStore.page + 1}
        onChange={handleChangePage}
        color="primary"
      />
    </Box>
  );
});

export default NotificationsPage;
